<p>
    {{'AUTH.RENEW.LINK' | translate}}
</p>
<p>
    {{'AUTH.RENEW.LINKFORM' | translate}}
</p>
